import rafpoly from '../../../vendor/polyfills/requestanimationframe'

export const SettingsPanelCustomCustomMixin = {
  data() {
    return {
      defaultDuration: 200
    }
  },
  methods: {
    syncConfigProperties(target, source) {
      for (let prop in target) {
        if (!target.hasOwnProperty(prop) || !source.hasOwnProperty(prop) || !source[prop]) {
          continue
        }

        const targetProp = target[prop]
        const sourceProp = source[prop]
        const targetPropIsObject = (typeof targetProp === 'object') && !Array.isArray(targetProp)
        const sourcePropIsObject = (typeof sourceProp === 'object') && !Array.isArray(sourceProp)

        if (!targetPropIsObject) {
          target[prop] = sourcePropIsObject ? JSON.parse(JSON.stringify(sourceProp)) : sourceProp
          continue
        }

        if (sourcePropIsObject) {
          this.syncConfigProperties(targetProp, sourceProp)
        }

        // we discard the source prop since the target prop is an object and source prop isn't. incompatible types.
      }
    },
    expandList(refName) {
      this.collapseList()

      if (!refName) {
        return
      }

      const list = this.$refs[refName] as HTMLElement

      if (!list) {
        return
      }

      this.animate(list, 0, this.getHeight(list), () => list.style.height = '')
    },
    collapseList() {
      const list = this.$el.querySelector('.is-selected-list')

      if (!list) {
        return
      }

      this.animate(list, this.getHeight(list), 0, () => list.style.display = 'none')
    },
    animate(el: HTMLElement, fromHeight: number, toHeight: number, cbDone?: Function) {
      const duration = this.defaultDuration
      let numIterations = duration / (1000 / 60)
      const stepSize = (toHeight - fromHeight) / numIterations
      let currentHeight = fromHeight
      let requestID

      el.style.height = fromHeight + 'px'
      el.style.display = 'block'

      const animation = () => {
        currentHeight += stepSize
        el.style.height = currentHeight + 'px'

        numIterations--

        if (numIterations <= 0) {
          cancelAnimationFrame(requestID)
          el.style.height = toHeight + 'px'
          if (cbDone) {
            cbDone()
          }
          return
        }

        requestID = requestAnimationFrame(animation)
      }

      animation()
    },
    getHeight(el: HTMLElement) {
      const origDisplay = el.style.display
      const origHeight = el.style.height

      el.style.display = 'block'
      el.style.height = 'auto'

      const height = el.offsetHeight

      el.style.display = origDisplay
      el.style.height = origHeight

      return height
    }
  },
  created(): void {
    // make sure window.requestanimationframe exists
    rafpoly()
  }
}
